module.exports = __webpack_public_path__ + "img/เนื้อปลาแอนโชวี่.8abd8ab9.jpg";